import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Box,
} from "@mui/material";
import ApiUrl from "../../../services/shared/ApiUrl";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
import { Link } from "react-router-dom";

interface Corporate {
  id: number;
  business_name: string;
  corporate_logo: string | null;
  total_bookings: number;
}

interface CorporateProps {
  corporates: Corporate[];
  height: any;
}

const TopCorporates = ({ corporates, height }: CorporateProps) => {
  const hasData = corporates && corporates.length > 0;

  const mediaUrl = ApiUrl.fileBaseUrl;
  return (
    <div className="card h-full">
      <div className=" card-header dashboard-card-header">
        <h6 className="mb-0 fw-semibold">Top Corporates</h6>
        <button
          type="button"
          className="text-decoration-none btn btn-link btn-sm veiw-all-btn"
        >
          <Link to="/corporatelist">
            View All <ArrowOutwardOutlinedIcon sx={{ fontSize: 16 }} />
          </Link>
        </button>
      </div>
      {/* <CardHeader
        title={<Typography variant="h6" className="">Top Corporates</Typography>}
      /> */}
      <CardContent sx={{ p: 0 }} className={height}>
        {hasData ? (
          <List>
            {corporates?.map((corp, index) => (
              <ListItem key={index}>
                <ListItemAvatar>
                  <Avatar
                    src={mediaUrl + corp.corporate_logo || undefined}
                    alt={corp.business_name}
                  >
                    {corp.business_name[0]} {/* fallback letter */}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="subtitle2">
                      {corp.business_name}
                    </Typography>
                  }
                  secondary={`${corp.total_bookings} Bookings`}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
            }}
          >
            <Typography variant="body2" align="center">
              No corporates found
            </Typography>
          </Box>
        )}
      </CardContent>
    </div>
  );
};

export default TopCorporates;
